//
// TooltipMapController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-gtl/models/layoutOverlayMap/map/MapPin";
import "../../controllers/visualElements/MapElementController";

var TooltipMapController = createModule("BIRD_TooltipMapController", [40467], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        reverseGeocode: [0],
        doDriveTimeWithTraffic: [0,5,4,4,4,4,4],
        canDoDistanceSelections: [2],
        doDriveTime: [0,5,4],
        getMapElementController: [1],
        cancelDriveTime: [0],
        cancelReverseGeocode: [0],
        doMultiDriveTime: [0,[5],4],
        cancelSearch: [0],
        doRadial: [0,5,4],
        canDoDriveTime: [2],
        getPin: [1],
        doMultiDriveTimeWithTraffic: [0,[5],4,4,4,4,4],
        doSearch: [0,7],
        getViewSize: [13,4],
        createPointBuffer: [0,1,4],
    },
    ,
    ,
]);
export default TooltipMapController;
